<template>
	<div class="team-talk-room">
		<div class="team-name-area">
			<span class="team-name">{{currentTeamName}}</span>
		</div>

		<div class="message-list" ref="message_list" @scroll="onMessageListScroll">	
				<div v-for="(row, index) in messages" :key="index" class="message-area" :style="messageStyle(row)">
					<div class="message-info">
						<div class="staff horizontal-center">
							<div class="avatar">
								<common-avatar 
									:staffId="row.staff.id"
									:name="row.staff.name"
									:image="row.staff.avatar"
									:isTeam="false"
									:teamId="currentTeamId"
									:width="40"
									fromRoute="team-talk">
								</common-avatar>
							</div>
							<span class="bold16 staff-name">{{row.staff.name}}</span>
						</div>

						<div class="message-info-right">
							<p><i v-if="row.staff.id == $store.state.auth.id" class="fas fa-trash" @click="onMessageDeleteClick(row.id)"></i></p>
							<span class="post-date">{{formatPostDate(row.created)}}</span>
						</div>
					</div>
					
					<div v-if="row.type == 'text'" class="message-text word-wrap" v-html="row.data.body"></div>
					<div v-else-if="row.type == 'image'" class="message-image">
						<img v-lazy="row.data.thumbnail_url" @click="onClickThumbnail(row.data)">
					</div>
					<div v-else-if="row.type == 'file'" class="message-file" v-html="replaceHyperlinkInMessage(row.data.dl_url, row.data.name)"></div>

					<div class="reaction-area">
						<div class="reaction-select">
						<twemoji-picker @emojiAddedInMessage="onEmojiAddedInMessage" emojiUnicodeAddedHandlerName="emojiAddedInMessage" :options="{messageId:row.id, messageIndex: index}">
								<img :src="require('@/assets/icons/team_talk/smile.svg')" slot="twemoji-picker-button" style="width: 32px; height: 32px">
						</twemoji-picker>
						</div>
						<div class="reaction-list">
						<div v-for="(reaction, reactionIndex) in row.reactions" :key="reactionIndex" class="reaction-wrap" @click="onClickReaction(row.id, reaction, index)">
								<span class="bold18 reaction-text">{{reaction.value}}</span>
								<span class="reaction-count">{{reaction.staffs.length}}</span>
						</div>
						</div>
						<div v-if="row.reactions.length > 0" class="reaction-staff-list">
							<b-dropdown aria-role="list" append-to-body scrollable position="is-top-right" @active-change="onReactionStaffListActiveChange">
								<a class="horizontal-center" slot="trigger" role="button">
									<img :src="require('@/assets/icons/team_talk/member_list.svg')" style="width: 32px; height: 32px">
								</a>
								<b-tabs v-model="reactionStaffListActiveTabIndex" :animated="false" class="reaction-staff-list-tab">
									<template v-for="(reaction, reactionIndex) in row.reactions">
										<b-tab-item :label="reaction.value" :key="reactionIndex">
											<template v-for="(staff, staffIndex) in reaction.staffs">
												<div class="reaction-staff-list-item" :key="staffIndex">
													<avatar :image="staff.avatar" :isTeam="false" :width="20"></avatar>
													<span class="staff-name">{{staff.name}}</span>
												</div>
											</template>
										</b-tab-item>
									</template>
								</b-tabs>
								
							</b-dropdown>
						</div>
						<span class="read-count" @click="onReadCountClick(row.unread_staffs)">既読&nbsp;{{row.read_count}}人/{{currentTeamStaffCount}}人</span>
					</div>
				</div>
		</div>

		<div class="message-input-area">
			<textarea class="message-input" v-model="message" ref="message_input" placeholder="メッセージを入力" @keydown="adjustHeight"></textarea>
			<div class="message-toolbox">
				<div class="img-wrap img-button">
					<twemoji-picker @emojiAddedInInput="onEmojiAddedInInput" emojiUnicodeAddedHandlerName="emojiAddedInInput">
						<img :src="require('@/assets/icons/team_talk/smile.svg')" slot="twemoji-picker-button" style="width: 32px; height: 32px">
					</twemoji-picker>
				</div>
				<div class="img-wrap">
					<b-dropdown aria-role="list" append-to-body scrollable position="is-top-right">
						<a class="horizontal-center" slot="trigger" role="button">
							<img :src="require('@/assets/icons/team_talk/atmark.svg')" style="width: 32px; height: 32px">
						</a>
						<div v-for="(staff, index) in currentTeamStaffs" :key="index">
							<b-dropdown-item aria-role="listitem" @click="onClickMention(index)">
								<div class="mention-staff-list-item">
									<avatar :image="staff.avatar" :isTeam="false" :width="20"></avatar>
									<span class="staff-name">{{staff.name}}</span>
								</div>
							</b-dropdown-item>
						</div>
					</b-dropdown>
				</div>
				<div class="img-wrap">
					<b-field class="file">
						<b-upload v-model="uploadingFile" @input="onFileChange" :loading="isFileUploading">
							<a class="horizontal-center">
								<img :src="require('@/assets/icons/team_talk/clip.svg')" style="width: 32px; height: 32px">
							</a>
						</b-upload>
					</b-field>
				</div>
				<div class="img-wrap">
					<img :src="require('@/assets/icons/team_talk/line.svg')" :class="{'is-click': false}" style="width: 32px; height: 32px">
				</div>
				<div class="img-wrap img-button">
					<img :src="require('@/assets/icons/team_talk/send.svg')" :class="{'is-click': true}" @click="onClickSend" style="width: 32px; height: 32px">
				</div>
			</div>
		</div>

		<b-modal :active.sync="isModalActive">
			<confirm-modal :body="`ファイルサイズの上限（${uploadingSizeLimit/1000000}MBまで）を超えているため、アップロードできません。`" :isCancelButtonShow="false" okButtonTitle="OK" @ok-click="isModalActive = false"></confirm-modal>
		</b-modal>

		<b-modal :active.sync="isImagePreviewModalActive">
			<image-preview-modal :image="previewImageUrl" :name="previewImageName" okButtonTitle="OK" @ok-click="isImagePreviewModalActive = false"></image-preview-modal>
		</b-modal>

		<b-modal :active.sync="isUnreadStaffModalActive">
			<unread-staff-modal :staffs="unreadStaffs"></unread-staff-modal>
		</b-modal>

		<div v-if="$utils.isApp()">
			<loading :active.sync="isLoadingViewShowing" :can-cancel="false" :is-full-page="true"></loading>
		</div>
		<div v-else>
			<b-loading :active.sync="isLoadingViewShowing" :can-cancel="false" :is-full-page="true"></b-loading>
		</div>

		<b-modal :active.sync="isMessageDeleteModalActive">
			<message-delete-confirm-modal title="" body="メッセージを削除しますか？削除すると元には戻せません。" okButtonTitle="削除" @ok-click="onMessageDeleteOkClick" @cancel-click="isMessageDeleteModalActive = false"></message-delete-confirm-modal>
		</b-modal>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar'
import CommonAvatar from '@/components/CommonAvatar'
import ConfirmModal from '@/components/ConfirmModal'
import MessageDeleteConfirmModal from '@/components/ConfirmModal'
import ImagePreviewModal from '@/components/ImagePreviewModal'
import UnreadStaffModal from '@/components/UnreadStaffModal'
import TwemojiPicker from '@/components/TwemojiPicker'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueLazyload from 'vue-lazyload';
import Vue from 'vue'
import moment from 'moment'

Vue.use(VueLazyload);

export default {
	name: 'TeamTalkRoomComponent',
	components: {
		Avatar,
		CommonAvatar,
		ConfirmModal,
		MessageDeleteConfirmModal,
		ImagePreviewModal,
		UnreadStaffModal,
		TwemojiPicker,
		Loading,
	},
	props: {
		team: {
			type: Object,
			default: null,
		},
		teams: {
			type: Array,
			default: null,
		},
		isRoomShowed: {
			type: Boolean,
			default: false,
		}
	},
	data () {
		const uploadingSizeLimit = 10000000;
		return {
			uploadingSizeLimit,
			isModalActive: false,
			isImagePreviewModalActive: false,
			isUnreadStaffModalActive: false,
			isFileUploading: false,
			isSubmitLoading: false,
			isMessageLoading: false,			// メッセージ取得中フラグ。重複取得処理防止に仕様。
			isLoadingViewShowing: false,	// ローディングスピン表示切り替えフラグ
			isMessageRefreshing: false,	 // メッセージリストの描画中状態フラグ
			currentTeam: null,
			currentTeamStaffCount: 0,
			currentTeamStaffs: {},
			messages: [],
			message: '',
			mentions: [],
			uploadingMessage: '',
			uploadingFile: null,
			refreshMessageTimer: null,
			previewImageUrl: '',
			previewImageName: '',
			reactionStaffListActiveTabIndex: 0,
			unreadStaffs: [],
			isMessageDeleteModalActive: false,
			deleteMessageId: null,
		}
	},
	created() {
	},
	mounted() {
		if (this.$utils.isApp()) window.addEventListener('scroll', this.onWindowScroll);
		//window.addEventListener('scroll', this.onWindowScroll);
		this.init();
	},
	updated() {
		// this.$utils.log('updated');
		// this.$utils.log('isMessageRefreshing = ' + this.isMessageRefreshing);
		// メッセージ一覧再描画フラグを確認
		if (this.isMessageRefreshing) {
				this.scrollToEnd();
			this.setMessageRefreshing(false);
		}
	},
	beforeDestroy () {
		if (this.$utils.isApp()) window.removeEventListener('scroll', this.onWindowScroll);
		if (this.refreshMessageTimer) clearInterval(this.refreshMessageTimer);
	},
	watch: {
		team: function(newTeam) {
			this.currentTeam = newTeam;
			this.init();
		},
		$route (to, from) {
			this.$utils.log('TeamTalkRoomComponent watch.');
			this.$utils.log(to.name);
			if (to.name === 'team-talk-view') this.scrollToEnd();
		}
	},
	computed: {
		currentTeamName: function() {
			if (this.currentTeam) {
				return this.currentTeam.name;
			} else {
				return '';
			}
		},
		currentTeamId: function() {
			if (this.currentTeam) {
				return this.currentTeam.id;
			} else {
				return '';
			}
		},
	},
	methods: {
		onReadCountClick: function(staffs) {
			this.$utils.log('onReadCountClick');
			this.$utils.log(staffs);
			this.unreadStaffs = staffs;
			this.isUnreadStaffModalActive = true;
		},
		onMessageDeleteClick: function(id) {
			this.deleteMessageId = id;
			this.isMessageDeleteModalActive = true;
		},
		onMessageDeleteOkClick: async function() {
			let ep = 'TeamTalk/delete';
			this.$utils.log(ep);

			let data = {
				"id": this.deleteMessageId,
			};

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);

				for (let i in this.messages) {
					if (this.messages[i].id === this.deleteMessageId) {
						this.messages.splice(i, 1);
						break;
					}
				}
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isMessageDeleteModalActive = false;
			}
		},
		adjustHeight: function() {
			const maxH = 120;
			const textarea = this.$refs.message_input;
			const resetHeight = new Promise(function(resolve) {
				if (textarea.scrollHeight < maxH) {
					resolve(textarea.style.height = 'auto')
				}
			});
			resetHeight.then(function(){
				textarea.style.height = textarea.scrollHeight + 'px'
			});
		},
		init: function() {
			this.getData();
			document.addEventListener('visibilitychange', () => {
				this.setTimerInterval();
			});
			this.setTimerInterval();
		},
		getData: async function() {
			this.setLoadingViewShowing(true);

			try {
				let teams = this.teams;
				if (!teams || teams.length == 0) {
					teams = await this.getTeams();
				}

				if (this.$route.params.teamId) {
					this.currentTeam = teams.find((team) => {
						return (team.id === this.$route.params.teamId);
					});
				}
				if (!this.currentTeam) this.currentTeam = teams[0];
				
				await this.refreshCurrentTeamMessage();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.setLoadingViewShowing(false);
			}
		},
		
		refreshCurrentTeamMessage: async function() {
			await this.getStaffs(this.currentTeam.id);
			await this.getCurrentTeamMessage();
		},
		getCurrentTeamMessage: async function() {
			if (this.currentTeam) {
				await this.getMessage(this.currentTeam.id);
			}
		},
		getCurrentTeamUpdateMessage: async function() {
			if (this.currentTeam) {
				await this.getMessage(this.currentTeam.id, 'update');
			}
		},
		getCurrentTeamOldMessage: async function() {
			if (this.currentTeam) {
				await this.getMessage(this.currentTeam.id, 'max');
			}
		},
		getCurrentTeamNewMessage: async function() {
			if (this.currentTeam) {
				await this.getMessage(this.currentTeam.id, 'min');
			}
		},
		getTeams: async function() {
			let ep = 'TeamTalk/getTeams';
			// this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				// this.$utils.log(res.data.teams);
				return res.data.teams;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			}
		},
		getMessage: async function(teamId, addType='none') {
			if (!this.isRoomShowed) return;
			if (this.isMessageLoading) return;

			this.setMessageLoading(true);
			let ep = 'TeamTalk/getMessage?team_id=' + teamId;
			if (this.messages.length > 0) {
				if (addType === 'max') {
					ep += '&max_id=' + this.messages[0].id
				}
				else if (addType === 'min') {
					ep += '&min_id=' + this.messages[this.messages.length - 1].id
				}
				// update時のメッセージ削除対応
				// 過去メッセージも含む現在取得済みメッセージの最古から全て取得しなおし
				else if (addType === 'update') {
					ep += '&min_id=' + this.messages[0].id
				}
			}
			//this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				//this.$utils.log(res.data);
				let messages = res.data.messages;

				for (let i = 0; i < messages.length; i++) {
					if (messages[i].type === 'text') {
						messages[i].data.body = this.replaceMessageText(messages[i].data.body);
					}
				}

				// ローディング表示と負荷がぶつからないようするためのsleep処理
				const sleep = msec => new Promise(resolve => setTimeout(resolve, msec));
				// if (this.isLoadingViewShowing) {
				if (addType === 'max') {
					const initialHeight = this.$refs.message_list.scrollHeight;
					const reversed = messages.reverse();
					for (let i = 0; i < reversed.length; i++) {
						this.messages.unshift(reversed[i]);
						if (i % 5 == 0) {
							await sleep(300);
						}
					}
					const self = this;
					this.$nextTick(() => {
						if (self.$utils.isApp()) {
							window.scroll(0, self.$refs.message_list.scrollHeight - initialHeight);
						} else {
							self.$refs.message_list.scrollTop = self.$refs.message_list.scrollHeight - initialHeight;
						}
						//window.scroll(0, self.$refs.message_list.scrollHeight - initialHeight);
					});
				}
				else if (addType === 'min') { 
					for (let i = 1; i < messages.length; i++) {
						this.messages.push(messages[i]);
						if (i % 5 == 0) {
							await sleep(300);
						}
					}
				}
				else if (addType === 'update') {
					this.messages = messages;
				}
				else {
					this.messages = [];
					for (let i = 0; i < messages.length; i++) {
						this.messages.push(messages[i]);
						if (i % 5 == 0) {
							await sleep(300);
						}
					}
					// メッセージ一覧再描画のフラグ
					this.setMessageRefreshing(true);
				}
				// } else {
				//	 this.messages = messages;
				// }
				this.$emit('update-read', teamId);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.setMessageLoading(false);
			}
		},
		getStaffs: async function(teamId) {
			let ep = `TeamTalk/getStaffs?team_id=${teamId}`;
			// this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				// this.$utils.log(res);
				this.currentTeamStaffCount = res.data.staffs.length;
				this.currentTeamStaffs = {};
				for (let i = 0; i < res.data.staffs.length; i++) {
					this.$set(this.currentTeamStaffs, res.data.staffs[i].id, res.data.staffs[i]);
				}
				// this.$utils.log(this.currentTeamStaffs);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			}
		},
		onClickMention: function(staffId) {
			const messageInput = this.$refs.message_input;
			let cursorPosition = messageInput.selectionEnd;
			const mentionText = '[to:' + (this.mentions.length + 1) + ':' + this.currentTeamStaffs[staffId].name +']';
			this.message = this.message.substring(0, cursorPosition) + mentionText + this.message.substring(cursorPosition);
			this.mentions.push(staffId);
			cursorPosition += mentionText.length;
			this.$nextTick(() => messageInput.setSelectionRange(cursorPosition, cursorPosition));
		},
		onClickReaction: function(messageId, reaction, messageIndex) {
			// this.$utils.log('onClickReaction');
			const emojiUnicode = reaction.value;
			let isDelete = 0;
			for (let i = 0; i < reaction.staffs.length; i++) {
				if (reaction.staffs[i].id === this.$store.state.auth.id) {
					isDelete = 1;
				}
			}
			this.sendReaction(messageId, this.currentTeam.id, emojiUnicode, isDelete, messageIndex)
		},
		onClickThumbnail: function(imageInfo) {
			// this.$utils.log(imageInfo);
			this.previewImageUrl = imageInfo.original_url;
			this.previewImageName = imageInfo.name;
			this.isImagePreviewModalActive = true;
		},
		onClickSend: async function() {
			// this.isModalActive = false;

			for (let key in this.errors) {
				this.errors[key] = '';
			}

			let ep = 'TeamTalk/sendMessage';
			// this.$utils.log(ep);

			this.isSubmitLoading = true;

			try {
				this.uploadingMessage = this.message;
				this.message = '';
				let res = await this.$api.post(ep, this.createSubmitData('text'), true);
				await this.getCurrentTeamNewMessage();
					this.scrollToEnd();
				this.mentions = [];
				// this.$utils.log(res);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isSubmitLoading = false;
			}
		},
		onFileChange: function() {
			// this.$utils.log(this.uploadingFile);
			if (this.uploadingFile.size > this.uploadingSizeLimit) {
				this.isModalActive = true;
				return;
			}

			let reader = new FileReader();
			reader.readAsDataURL(this.uploadingFile);
			reader.onload = (e) => {
				this.uploadFile(e.target.result);
			};
		},
		uploadFile: async function(base64File) {
			this.setLoadingViewShowing(true);
			this.isFileUploading = true;

			let ep = 'TeamTalk/sendMessage';
			// this.$utils.log(ep);

			try {
				let type = '';
				if (this.uploadingFile.type.match(/^image\/.*/)) {
					type = 'image';
				} else {
					type = 'file';
				}
				let res = await this.$api.post(ep, this.createSubmitData(type, base64File), true);
				// this.$utils.log(res);
				await this.getCurrentTeamNewMessage();
					this.scrollToEnd();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.setLoadingViewShowing(false);
				this.isFileUploading = false;
			}
		},
		createSubmitData: function(type, base64File) {
			let data = {
				"team_id": this.currentTeam.id,
				"type": type,
			};

			if (type == 'text') {
				const message = this.replaceMentionInput(this.uploadingMessage);
				data.text_body = message;
			}
			else if (type == 'image') {
				data.image_name = this.uploadingFile.name;
				data.image_data = base64File;
			}
			else if	(type == 'file') {
				data.file_name = this.uploadingFile.name;
				data.file_data = base64File;
			}

			// this.$utils.log(data);
			return data;
		},
		onEmojiAddedInMessage: async function(emojiUnicode, options) {
			// this.$utils.log(emojiUnicode);
			// this.$utils.log(options);
			const isDelete = 0;
			this.sendReaction(options.messageId, this.currentTeam.id, emojiUnicode, isDelete, options.messageIndex)
		},
		sendReaction: async function(messageId, teamId, emojiUnicode, isDelete, messageIndex) {
			let ep = 'TeamTalk/sendReaction';
			// this.$utils.log(ep);

			try {
				let data = {
					message_id: messageId,
					team_id: teamId,
					reaction_value: emojiUnicode,
					is_delete: isDelete,
				}
				let res = await this.$api.post(ep, data, true);
				// this.$utils.log(res);
				let message = res.data.messages[0];
				if (message.type === 'text') {
					message.data.body = this.replaceMessageText(message.data.body);
				}
				this.$set(this.messages, messageIndex, message);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			}
		},
		onEmojiAddedInInput: function(emojiUnicode) {
			// this.$utils.log(emojiUnicode);
			const messageInput = this.$refs.message_input;
			let cursorPosition = messageInput.selectionEnd;
			this.message = this.message.substring(0, cursorPosition) + emojiUnicode + this.message.substring(cursorPosition);
			cursorPosition += emojiUnicode.length;
			this.$nextTick(() => messageInput.setSelectionRange(cursorPosition, cursorPosition));
		},
		onReactionStaffListActiveChange: function(active) {
			this.reactionStaffListActiveTabIndex = 0;
		},
		onMessageListScroll: async function(event) {
			// this.$utils.log(event.target.scrollTop);
			if (!this.isMessageLoading && event.target.scrollTop == 0) {
				this.setLoadingViewShowing(true);
				await this.getCurrentTeamOldMessage();
				this.setLoadingViewShowing(false);
			}
		},
		onWindowScroll: async function() {
			this.$utils.log('onWindowScroll');
			this.$utils.log(window.pageYOffset);
			if (!this.isMessageLoading && window.pageYOffset < 30) {
				this.setLoadingViewShowing(true);
				await this.getCurrentTeamOldMessage();
				this.setLoadingViewShowing(false);
			}
		},
		scrollToEnd: function() {
			this.$utils.log('Room scrollToEnd');
			const self = this;
			this.$nextTick(() => {
				const messageList = self.$refs.message_list;
				if (!messageList) {
					this.$utils.log('messageList elment is null');
					return;
				}
				if (!messageList.lastElementChild) {
					this.$utils.log('messageList lastElement is null');
					return;
				}
				messageList.scrollTop = messageList.lastElementChild.offsetTop;
				if (this.$utils.isApp()) window.scroll(0, 99999);

				// 代替処理
				// messageList.lastElementChild.scrollIntoView(false);
				});
		},
		replaceMessageText: function(message) {
			let replaced = this.replaceMentionText(message);
			replaced = this.$utils.hyperlink(replaced);
			return replaced;
		},
		replaceMentionText: function(message) {
			const currentTeamStaffs = this.currentTeamStaffs;
			function getStaffNameText(match, staffId, offset, message) {
				if (currentTeamStaffs[staffId]) {
					return '<span style="color:#4183C4;">@'+currentTeamStaffs[staffId].name+'&nbsp;</span>';
				}
				return '';
			}
			let reg = /\[to:([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})]/igm;
			let ids = message.match(reg);
			if (ids) {
				// eslint-disable-next-line no-useless-escape
				reg = /\[to:([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})]/igm;
				return message.replace(reg, getStaffNameText);
			}
			return message;
		},
		replaceMentionInput: function(message) {
			const mentions = this.mentions;
			function getStaffIdText(match, index, message) {
				if (mentions[index-1]) {
					return '[to:' + mentions[index-1] + ']';
				}
				return '';
			}
			// eslint-disable-next-line no-useless-escape
			let reg = /\[to:(\d+):[^\]]*]/igm;
			return message.replace(reg, getStaffIdText);
		},
		replaceHyperlinkInMessage(dlUrl, filename) {
			if (this.$utils.isApp()) {
				return '<a href="openbrowser:' + dlUrl +' ">' + filename + '</a>';
			} else {
				return '<a href="' + dlUrl + '" target="_blank">' + filename + '</a>';
			}
		},
		formatPostDate(postDate) {
			moment.locale('ja');
			const formatDate = moment(postDate).format('YYYY-MM-DD dd HH:mm');
			return formatDate;
		},
		setTimerInterval: function() {
			if (document.visibilityState === "visible") {
				if (this.refreshMessageTimer) clearInterval(this.refreshMessageTimer);
				let self = this;
				this.refreshMessageTimer = setInterval(function() {
					self.getCurrentTeamUpdateMessage();
				}, 3000);
			} else if (document.visibilityState === "hidden") {
				if (this.refreshMessageTimer) clearInterval(this.refreshMessageTimer);
			}
		},
		setLoadingViewShowing: function(isLoading) {
			// this.$utils.log('setLoadingViewShowing = ' + isLoading);
			this.isLoadingViewShowing = isLoading;
		},
		setMessageRefreshing: function(isRefresing) {
			// this.$utils.log('setMessageRefreshing = ' + isRefresing);
			this.isMessageRefreshing = isRefresing;
		},
		setMessageLoading: function(isLoading) {
			// this.$utils.log('setMessageLoading = ' + isLoading);
			this.isMessageLoading = isLoading;
		},
		messageStyle: function(message) {
			if (message.staff.id == this.$store.state.auth.id) {
				return {'background-color': 'rgba(195, 246,157, 0.5)'};
			}
			else {
				return {'background-color': '#FFFFFF'};
			}
		}
	}
}
</script>

<style lang="scss">
</style>
